import {Container, Grid, Image} from "semantic-ui-react";
import React, {Component} from 'react'
import {DawidConfirm} from "./confirm.jsx";

export default class DawidHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            resetOpen: false
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !(this.props.logo === nextProps.logo && this.props.width === nextProps.width && this.state === nextState)
    }

    render() {
        const {width, logo, resetSession} = this.props;
        return (<Container fluid style={{marginTop: '2em', marginBottom: '2em'}}>
            <Grid centered columns={1}>
                <Grid.Column width={width}>
                    <Image title={"Click here to restart from the beginning"} style={{cursor: 'pointer'}} onClick={() =>
                        this.setState({resetOpen: true})
                    }
                           alt='Data agreement wizard' size='medium'
                           src={logo}
                           id={"logo"}/>
                </Grid.Column>
            </Grid>
            <DawidConfirm open={this.state.resetOpen}
                          onConfirm={() => {
                              resetSession();
                              this.setState({resetOpen: false})
                          }}
                          onCancel={() => this.setState({resetOpen: false})}/>
        </Container>)
    }
}